export default "__VITE_ASSET__79b0cb36__"